import {useEffect, useState} from "react";
import {UseFieldArrayAppend, UseFieldArrayRemove} from "react-hook-form";
import {SessionPricingFormFieldsType} from "../types";
import {Currency} from "../../../../../../calls/useCases/createService/types";
import {usePricingCurrencies} from "@/features/currencies";

type FunctionToAppendNewCurrency = UseFieldArrayAppend<
  SessionPricingFormFieldsType,
  "currencies"
>;

export function useCurrencyOptions(
  currencyArray: Currency[],
  defaultCurrency: string,
  functionToAppendNewCurrency: FunctionToAppendNewCurrency,
  funcToRemoveCurrency: UseFieldArrayRemove
) {
  const {formCurrencies} = usePricingCurrencies();
  const [currencyOptions, setCurrencyOptions] = useState(formCurrencies);

  //   const newCurrencyArray = useMemo(() => {
  //     const alreadyPickedCurrencies = [
  //       ...currencyArray.map((currency) => currency.callPriceCurrency.toLowerCase()),
  //       defaultCurrency.toLowerCase(),
  //     ];
  //     const newCurrencyOptions = state.formCurrencies.filter(
  //       (currencyOption) => !alreadyPickedCurrencies.includes(currencyOption.toLowerCase())
  //     );

  //     return newCurrencyOptions;
  //   }, [currencyArray, defaultCurrency, state.formCurrencies]);

  useEffect(() => {
    const alreadyPickedCurrencies = [
      ...currencyArray.map((currency) => currency.callPriceCurrency.toLowerCase()),
      defaultCurrency.toLowerCase(),
    ];
    const newCurrencyOptions = formCurrencies.filter(
      (currencyOption) => !alreadyPickedCurrencies.includes(currencyOption.toLowerCase())
    );

    setCurrencyOptions(newCurrencyOptions);
  }, [currencyArray, defaultCurrency, formCurrencies]);

  function addNewCurrency() {
    const alreadyPickedCurrencies = [
      ...currencyArray.map((currency) => currency.callPriceCurrency.toLowerCase()),
      defaultCurrency.toLowerCase(),
    ];
    const newCurrencyOptions = formCurrencies.filter(
      (currencyOption) => !alreadyPickedCurrencies.includes(currencyOption.toLowerCase())
    );

    const copyNewCurrencyOptions = [...newCurrencyOptions];
    newCurrencyOptions.shift();
    setCurrencyOptions(newCurrencyOptions);
    functionToAppendNewCurrency({
      callPriceCurrency: copyNewCurrencyOptions[0],
      callPrice: 1,
    });
  }
  function removeCurrency(index: number) {
    const alreadyPickedCurrencies = [
      ...currencyArray.map((currency) => currency.callPriceCurrency.toLowerCase()),
      defaultCurrency.toLowerCase(),
    ];
    const newCurrencyOptions = formCurrencies.filter(
      (currencyOption) => !alreadyPickedCurrencies.includes(currencyOption.toLowerCase())
    );
    funcToRemoveCurrency(index);
    setCurrencyOptions(newCurrencyOptions);
  }
  function handleCurrencySelectChange(value: string, onChangeFunc: any) {
    onChangeFunc(value);
    const currencies = currencyArray;
    const alreadyPickedCurrencies = [
      ...currencies.map((currency) => currency.callPriceCurrency.toLowerCase()),
      defaultCurrency,
    ];
    const newCurrencyOptions = formCurrencies.filter(
      (currencyOption) =>
        !alreadyPickedCurrencies.includes(currencyOption.toLowerCase()) &&
        currencyOption.toLowerCase() !== value
    );

    setCurrencyOptions(newCurrencyOptions);
  }

  return {
    currencyOptions,
    addNewCurrency,
    removeCurrency,
    handleCurrencySelectChange,
  };
}
